module.exports = __webpack_public_path__ + "static/img/iorveth.eee78a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/iorveth.png
// module id = Z7gS
// module chunks = 0